var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.61984 3.23519L8.98793 5.96853C9.23713 6.25621 9.20563 6.70348 8.91723 6.99327L7.96524 7.94591C7.91364 7.99471 7.87963 8.05919 7.86849 8.12932C7.85734 8.19946 7.8697 8.27131 7.90364 8.33369C8.80041 9.89539 10.095 11.1916 11.6556 12.0904C11.7179 12.1241 11.7896 12.1364 11.8596 12.1252C11.9296 12.1141 11.994 12.0802 12.0427 12.0288L12.9975 11.0726C13.2852 10.7842 13.7311 10.752 14.0181 10.9984L16.7621 13.3538C17.0799 13.6268 17.0792 14.13 16.7607 14.4485L14.7951 16.4175C14.2155 16.9978 13.3545 17.1637 12.6643 16.8284C8.51944 14.8199 5.17447 11.4704 3.17166 7.32295C2.83636 6.63209 3.00226 5.77044 3.58186 5.19017L5.52925 3.23939C5.84635 2.92161 6.34685 2.92021 6.61984 3.23519Z",
    stroke: "#264742",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.f8aa1e8a84c34a7e94c27ca5b90d1d97.svg";
export { ForwardRef as ReactComponent };